<template>
  <div class="content page1">
    <el-row class="box">
      <el-col :span="24" class="box-item">
        <div class="box-item-li font-color2" style="padding: 20px 40px;">
          项目区域：{{info.area}}
          <!-- <p class="name"></p>
          <p class="val"></p>-->
        </div>
        <div class="box-item-li font-color2" style="padding: 20px 40px;">项目名称：{{info.groupName}}</div>
      </el-col>
      <el-col :span="24" class="box-item">
        <div class="box-item-li font-color2" style="padding: 20px 40px;">
          疫情防控负责人：{{info.diseaseManager}}
          <span style="display: inline-block;width: 40px;"></span>
          联系方式：{{info.managerPhone}}
        </div>
        <div class="box-item-li font-color2" style="padding: 20px 40px;">
          报表上报联系人：{{info.personName}}
          <span style="display: inline-block;width: 40px;"></span>
          联系方式：{{info.personPhone}}
        </div>
      </el-col>
      <el-col :span="24" class="box-item">
        <div class="box-item-li font-color2" style="padding: 20px 40px;">复工时间：{{info.workTime}}</div>
        <div
          class="box-item-li font-color2"
          style="padding: 20px 40px;"
        >管理人员复工时间：{{info.manageWorkTime}}</div>
      </el-col>
      <el-col :span="24" class="box-item flex-wrap">
        <div
          style="width:100%;height:40px;color:red;background:#CECECE;padding:0 20px;line-height: 40px;text-align: left;"
        >复工人员情况</div>
        <div class="box-item-li box3 font-color2" style="padding: 20px 40px;">
          <p>复工总人数</p>
          <p>{{info.headcount}}</p>
        </div>
        <div class="box-item-li box3 font-color2" style="padding: 20px 40px;">
          <p>从外地返合肥人数</p>
          <p>{{info.nonlocalPersonnel}}</p>
        </div>
        <div class="box-item-li box3 font-color2" style="padding: 20px 40px;">
          <p>“三类重点人群”情况</p>
          <p>0</p>
        </div>
      </el-col>
      <!-- <el-col :span="24" class="box-item">
                <div class="box-item-li box-w4 font-color1">
                    制定项目疫情防控工作方案是否符合要求：
                </div>
                <div class="box-item-li box-w3">
                    <el-radio-group v-model="info.isNotRequirements">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </div>
                <div class="box-item-li box-w3">
                    附件：
                    <div v-for="item in info.requirementsPhotos" :key="item" style="width: 50px; height: 50px;margin-right:5px;">
                        <el-image 
                            style="width: 50px; height: 50px"
                            :src="item" 
                            :preview-src-list="info.requirementsPhotos">
                        </el-image>
                    </div>
                </div>
            </el-col>
            <el-col :span="24" class="box-item">
                <div class="box-item-li box-w4 font-color1">
                    建立以建设单位项目负责人为组长的疫情防控工作组:
                </div>
                <div class="box-item-li box-w3">
                    <el-radio-group v-model="info.isNotWorkingGroup">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </div>
                <div class="box-item-li box-w3">
                    附件：
                    <div v-for="item in info.workingGroupPhotos" :key="item" style="width: 50px; height: 50px;margin-right:5px;">
                        <el-image 
                            style="width: 50px; height: 50px"
                            :src="item" 
                            :preview-src-list="info.workingGroupPhotos">
                        </el-image>
                    </div>
                </div>
            </el-col>
            <el-col :span="24" class="box-item">
                <div class="box-item-li box-w4 font-color1">
                    储备必须的疫情防控物资（主要包括口罩、测温仪、消毒液等）：
                </div>
                <div class="box-item-li box-w3">
                    <el-radio-group v-model="info.isNotSupplies">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </div>
                <div class="box-item-li box-w3">
                    附件：
                    <div v-for="item in info.suppliesPhotos" :key="item" style="width: 50px; height: 50px;margin-right:5px;">
                        <el-image 
                            style="width: 50px; height: 50px"
                            :src="item" 
                            :preview-src-list="info.suppliesPhotos">
                        </el-image>
                    </div>
                </div>
            </el-col>
            <el-col :span="24" class="box-item">
                <div class="box-item-li box-w4 font-color1 font18">
                    提前准备好应急隔离场所：
                </div>
                <div class="box-item-li box-w3 font18">
                    <el-radio-group v-model="info.isNotIsolation">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </div>
                <div class="box-item-li box-w3 font18">
                    附件：
                    <div v-for="item in info.isolationPhotos" :key="item" style="width: 50px; height: 50px;margin-right:5px;">
                        <el-image 
                            style="width: 50px; height: 50px"
                            :src="item" 
                            :preview-src-list="info.isolationPhotos">
                        </el-image>
                    </div>
                </div>
            </el-col>
            <el-col :span="24" class="box-item">
                <div class="box-item-li box-w4 font-color1 font18">
                    对拟返岗员工全员筛查（包括发热病人筛查、可疑人员排查）：
                </div>
                <div class="box-item-li box-w3 font18">
                    <el-radio-group v-model="info.isNotAMedical">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </div>
                <div class="box-item-li box-w3 font18">
                    附件：
                    <div v-for="item in info.medicalPhotos" :key="item" style="width: 50px; height: 50px;margin-right:5px;">
                        <el-image 
                            style="width: 50px; height: 50px"
                            :src="item" 
                            :preview-src-list="info.medicalPhotos">
                        </el-image>
                    </div>
                </div>
      </el-col>-->
      <el-col :span="24" class="box-item">
        <div class="box-item-li box-w4 font-color1">企业承诺书：</div>
        <div class="box-item-li box-w3 font18">
          原件：
          <div style="display:flex;flex-wrap: wrap;justify-content: center;">
            <img src="../../../../assets/image/word.png" style="width:40px;height:40px;margin: 0;" />
            <a
              target="_blank"
              :href="docx1"
              style="width: 100%;text-align: center;color:#36C635;"
            >下载</a>
          </div>
        </div>
        <div class="box-item-li box-w3 font18">
          附件：
          <a
            v-for="item in info.rectificationReports"
            :key="item"
            @click="showImage('1')"
            style="width: 50px; height: 50px;margin-right:5px;"
          >
            <!-- <el-image 
                            style="width: 50px; height: 50px"
                            :src="item" 
                            :preview-src-list="info.rectificationReports">
            </el-image>-->
            <img :src="item" style="width: 50px; height: 50px" />
          </a>
        </div>
      </el-col>
      <el-col :span="24" class="box-item">
        <div class="box-item-li box-w4 font-color1">工程建设项目“新冠肺炎”疫情防控期间复（开）工备案表：</div>
        <div class="box-item-li box-w3 font18">
          原件：
          <div style="display:flex;flex-wrap: wrap;justify-content: center;">
            <img src="../../../../assets/image/word.png" style="width:40px;height:40px;margin: 0;" />
            <a
              target="_blank"
              :href="docx2"
              style="width: 100%;text-align: center;color:#36C635;"
            >下载</a>
          </div>
        </div>
        <div class="box-item-li box-w3 font18">
          附件：
          <a
            v-for="item in info.backupTables"
            :key="item"
            @click="showImage('2')"
            style="width: 50px; height: 50px;margin-right:5px;cursor: pointer;"
          >
            <img :src="item" style="width: 50px; height: 50px" />
            <!-- <el-image 
                            style="width: 50px; height: 50px"
                            :src="item" 
                            :preview-src-list="info.backupTables">
            </el-image>-->
          </a>
        </div>
      </el-col>
      <!-- <el-col :span="24" class="box-item">
                <div class="box-item-li box-w4 font-color1">
                    复工人员健康信息登记（附件3）：
                </div>
                <div class="box-item-li box-w3 font18">
                    原件：<a v-for="item in info.healthRegistrations" :key="item" target="_blank" :href="item"><img src="../../../assets/images/word.png" style="width:50px;height:50px;" /></a>
                </div>
      </el-col>-->
      <el-col
        :span="24"
        class="box-item"
        style="padding:50px 50px 50px 0;justify-content: flex-end;background: transparent;"
      >
        <el-button type="warning" round v-if="info.approval=='0'" @click="applyFun1">不同意复工</el-button>
        <el-button
          type="primary"
          round
          v-if="info.approval=='0'"
          @click="applyFun"
          style="margin-left:50px;"
        >同意复工</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import myHttp from '../../../../untils/port'
import base from '../../../../untils/base'
import util from '../../../../untils/util'
export default {
  data() {
    return {
      info: {
        area: '',
        groupName: '',
        isNotRequirements: '1',
        isNotWorkingGroup: '1',
        isNotSupplies: '1',
        isNotIsolation: '1',
        isNotAMedical: '1'
      },
      id: '',
      port: '',
      docx1: base.httpCtx + '/wisdom/template/promise.docx',
      docx2: base.httpCtx + '/wisdom/template/records.docx'
    }
  },
  mounted() {
    this.entId = this.$store.state.groupId
    if ('' == this.entId) {
      this.$store.commit('setGroupId')
      this.entId = this.$store.state.groupId
    }
    this.port = util.session.get('roleId')
    if (this.$route.params.id == '0' && this.port == '4') {
      this.id = util.session.get('groupId')
    } else {
      this.id = this.$route.params.id
    }
    this.getData()
  },
  methods: {
    //获取数据
    getData() {
      let that = this
      myHttp
        .getBackworkDetail({
          groupId: this.id
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var data = resp.data.data.backwork
              that.showInfo(data)
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    //展示数据
    showInfo(data) {
      this.getCurArea()
      this.info.id = data.id
      this.info.groupName = data.groupName
      this.info.diseaseManager = data.diseaseManager
      this.info.managerPhone = data.managerPhone
      this.info.personName = data.personName
      this.info.personPhone = data.personPhone

      this.info.workTime = data.workTime
      this.info.manageWorkTime = data.manageWorkTime
      this.info.headcount = data.headcount
      this.info.nonlocalPersonnel = data.nonlocalPersonnel

      this.info.isNotRequirements = parseInt(data.isNotRequirements)
      this.info.isNotWorkingGroup = parseInt(data.isNotWorkingGroup)
      this.info.isNotSupplies = parseInt(data.isNotSupplies)
      this.info.isNotIsolation = parseInt(data.isNotIsolation)
      this.info.isNotAMedical = parseInt(data.isNotAMedical)

      this.info.requirementsPhotos = this.getImg(data.requirementsPhoto) //是否符合要求图片
      this.info.workingGroupPhotos = this.getImg(data.workingGroupPhoto) //工作组图片
      this.info.suppliesPhotos = this.getImg(data.suppliesPhoto) //储备物资图片
      this.info.isolationPhotos = this.getImg(data.isolationPhoto) //隔离场所图片
      this.info.medicalPhotos = this.getImg(data.medicalPhoto) //体检图片
      // this.info.healthRegistration = data.healthRegistration
      this.info.rectificationReport = data.rectificationReport
      this.info.backupTable = data.backupTable
      // this.info.healthRegistrations = this.getImg(data.healthRegistration)//复工人员健康信息登记（附件）
      this.info.rectificationReports = this.getImg(data.rectificationReport) //整改报告（表格）
      this.info.backupTables = this.getImg(data.backupTable) //备案表（附件）

      this.info.approval = data.approval
    },
    //获取区域
    getCurArea() {
      var that = this
      if (this.port == '2') {
        myHttp.getSuperviseById({ id: this.entId }).then(
          function(resp) {
            if (resp.data.code == '200') {
              let areaId = resp.data.data.supervise.areaId
              that.getAreaById(areaId)
            }
          },
          function() {}
        )
      } else if (this.port == '4') {
        myHttp
          .getProjectById({
            id: this.id
          })
          .then(
            function(resp) {
              if (resp.data.code == '200') {
                var data = resp.data.data.project
                if (data && data.areaId && '' != data.areaId) {
                  that.getAreaById(data.areaId)
                }
              }
            },
            function() {}
          )
      }
    },
    //根据id获取所属区域
    getAreaById(id) {
      var that = this
      myHttp.getAreaById({ id: id }).then(
        function(resp) {
          if (resp.data.code == '200') {
            let data = resp.data.data.area
            if (data.level == '1') {
              that.info.area = data.name
            } else if (data.level == '2') {
              that.info.area = data.provinceName + data.name
            } else {
              that.info.area = data.provinceName + data.cityName + data.name
            }
          }
        },
        function() {}
      )
    },

    //图片加工
    getImg(obj) {
      if (obj && obj != '') {
        let result = []
        var list = obj.split(',')
        for (var i = 0; i < list.length; i++) {
          var str = base.httpCtx + list[i]
          result.push(str)
        }
        return result
      } else {
        return []
      }
    },

    //审批(同意)
    applyFun(e) {
      var that = this
      myHttp
        .approveBackWork({
          id: this.info.id,
          approval: '1'
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              console.log(resp)
              that.$message.success('审核操作成功')
              // that.getData()
              that.$router.push({ name: 'rework' })
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {
            that.$message.error('服务器繁忙，请稍后再试')
          }
        )
    },

    //审批（不通过）
    applyFun1() {
      var that = this
      this.$prompt('请输入原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(({ value }) => {
          console.log(value)
          if (undefined == value || '' == value) {
            that.$message.error('请输入审批原因')
          } else {
            myHttp
              .approveBackWork({
                id: that.info.id,
                approval: '2',
                approvalReason: value
              })
              .then(
                function(resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('审核操作成功')
                    that.$router.go(0)
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function() {
                  that.$message.error('服务器繁忙，请稍后再试')
                }
              )
          }
        })
        .catch(() => {})
    },

    /**
     * 展示图片
     */
    showImage(str) {
      this.$router.push('/imgView/' + this.id + '/' + str)
      // console.log(str)
    }
  }
}
</script>
<style scoped>
.content {
  overflow: auto;
}
.page1 .el-col {
  margin-top: 10px;
  background-color: #fff;
  border-radius: 4px;
  padding: 10 20px;
}
/* .page1 .el-col div {
        padding: 20px 40px;
    } */
.box-item {
  display: flex;
}
.box-item-li {
  width: 50%;
  display: flex;
  align-content: center;
  align-items: center;
  font-size: 18px;
}
/* .box-item-li .name{
        width: 100%;
        font-weight: bold;
    } */
.flex-wrap {
  display: flex;
  flex-wrap: wrap;
}
.box-item-li.box3 {
  width: 33%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  justify-items: center;
  box-sizing: border-box;
}
.box-item-li.box3 p {
  width: 100%;
  margin: 0;
}
.box-item-li img {
  margin-right: 10px;
  margin-bottom: 10px;
}
.box-w4 {
  width: 40%;
  padding: 20px;
}
.box-w3 {
  width: 30%;
  padding: 10px;
}
.font-color1 {
  color: #4263f3;
}
.font-color2 {
  color: #000;
}
.font18 {
  font-size: 16px;
}
</style>
<style>
.el-image-viewer__close {
  color: red;
}
</style>